import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { ShareLink } from '#src/app/shared/hooks/share';

import type { PetitionShareLinksQuery, PetitionShareLinksQueryVariables } from './api.graphql';
import { PetitionShareLinks } from './api.graphql';

export async function getPetitionShareLinks({
	id,
	promotionToken,
	utilityContext,
}: {
	id: string;
	promotionToken: string | undefined;
	utilityContext: UtilityContext;
}): Promise<readonly ShareLink[]> {
	const { gql } = utilityContext;

	const { data } = await gql.fetch<PetitionShareLinksQuery, PetitionShareLinksQueryVariables>({
		query: PetitionShareLinks,
		variables: { id, promotionToken },
		rejectOnError: true,
	});

	return data.petition?.shareLinks.links ?? [];
}
